import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Input, Upload } from 'antd'
import axios from 'axios'
import React, { useState } from 'react'
import { ADMIN } from '../../../utils/apis'
import { assignMessage, errorMessage, successNotification, warningMessage } from '../../../utils/helpers'

const AddGiftCardImages = (props) => {
    const { onCancel, edit, user, selectedLanguage, language } = props
    const [loading, setLoading] = useState(false)
    const [fileList, setFileList] = useState([])
    const [checkboxValue, setCheckboxValue] = useState(false)
    const isEnglish = language?.language === 'english'


    const onFinish = (values) => {

        // console.log('values',values)
        values.file = fileList
        edit?._id && (values._id = edit?._id)
        values.adminId = user?._id
        // values.isAmountZero = checkboxValue

        if (!values._id && !values?.file?.length) {
            return warningMessage(selectedLanguage?.txt_PleaseUploadImage)
        }
        setLoading(true)

        let formData = new FormData()
        if (values?.file?.length) {
            formData.append('file', values?.file[0])
        }
        if (values?._id) {
            formData.append('_id', values?._id)
        }
        formData.append('name', values?.name)
        formData.append('adminId', values?.adminId)

        console.log('values', values)
        axios.post(ADMIN.CREATE_GIFT_CARD_IMAGES, formData)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data.success) {
                    successNotification(assignMessage(data?.message, language?.language))
                    console.log('data', data)
                    onCancel()
                    // getCards()
                }
                // errorMessage(data.message)
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
                console.log('e', e)
            })
    }
    const onChange = (e) => {
        setCheckboxValue(e?.target?.checked)
    }

    const normFile = (e) => {
        setFileList([])

        if (e?.fileList?.length && e?.file?.type !== 'image/png' && e?.file?.type !== 'image/jpeg') {
            errorMessage(selectedLanguage?.txt_PleaseUploadImage)
            return []
        }

        if (Array.isArray(e)) {
            return e
        }

        e?.fileList?.length ? setFileList([...[e?.file]]) : setFileList([])
        return e && [e.file]
    }

    return (
        <div >
            <h3 className='new-exam-title'>{selectedLanguage?.txt_AddGiftCardImages}</h3>
            <div style={{ padding: '15px' }}>
                <div style={{ textAlign: 'right', width: '98.5%' }}>
                    <Button
                        type='primary'
                        onClick={onCancel}
                    >
                        {selectedLanguage?.txt_Cancel}
                    </Button>
                </div>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                >
                    <Form.Item
                        name='name'
                        label={selectedLanguage?.txt_ImageName}
                        rules={[
                            {
                                required: true,
                                message: selectedLanguage?.txt_PleaseInputImageName
                            }
                        ]}
                    >
                        <Input
                            className='form-input'
                            placeholder={selectedLanguage?.txt_InputImageNameHere}
                        />
                    </Form.Item>


                    <Form.Item
                        name='file'
                        label={selectedLanguage?.txt_ImageImage}
                    >
                        <Upload
                            name='file'
                            multiple={false}
                            beforeUpload={() => false}
                            accept='image/png, image/jpeg'
                            onChange={normFile}
                            fileList={fileList}
                        >
                            <Button icon={<UploadOutlined />}>{selectedLanguage?.txt_ClickToUpload}</Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type='primary'
                            className='form-button'
                            block
                            htmlType='submit'
                            loading={loading}
                        >
                            {selectedLanguage?.txt_Create}
                        </Button>

                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default AddGiftCardImages